export default "__VITE_ASSET__ZKX7Qg6y__"